var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentMoneyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 11c0 .038 0 .076.002.114-.452-.125-.65-.314-.753-.468-.145-.218-.207-.502-.232-.896h.983V11zM14.748 11.114c.452-.125.65-.314.753-.468.145-.218.207-.502.232-.896h-.983V11c0 .038 0 .076-.002.114zM10.75 8.75V11a1.25 1.25 0 102.5 0V8.75h-2.5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19a1 1 0 001-1V6a1 1 0 00-1-1H3a1 1 0 00-1 1v12a1 1 0 001 1h18zM3.5 6.5v1.982A1.75 1.75 0 005.482 6.5H3.5zm.25 9c-.085 0-.168.006-.25.018V17.5h1.982a1.75 1.75 0 00-1.732-2zm16.75 2v-1.982a1.75 1.75 0 00-1.982 1.982H20.5zm0-11v1.982A1.75 1.75 0 0118.518 6.5H20.5zm-11.25.75h5.5v1h2.5v.838c.001.68.002 1.635-.501 2.39-.5.75-1.36 1.15-2.608 1.248a2.753 2.753 0 01-1.39.92v1.739H15a.75.75 0 010 1.5H9a.75.75 0 010-1.5h2.25v-1.739a2.752 2.752 0 01-1.392-.92c-1.248-.097-2.108-.498-2.608-1.248-.504-.755-.502-1.71-.501-2.39V8.25h2.5v-1z",
    fill: "currentColor"
  })));
}
SvgTournamentMoneyFilled.displayName = 'TournamentMoneyFilled';
export default SvgTournamentMoneyFilled;